import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, concatMap, mergeMap, withLatestFrom, exhaustMap } from 'rxjs/operators';
import { PermissionSetService, TenantPermissionAssigneeTargetLinkService, UserAppletService } from 'blg-akaun-ts-lib';
import { UserPermActions } from '../actions';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from '../../../../visa';
import { PermissionStates } from '../../permission-controller/root';
import { UserPermSelectors } from '../selectors';
import { Store } from '@ngrx/store';

@Injectable()
export class UserPermEffects {

    private readonly apiVisa = AppConfig.apiVisa;

    updateUser$ = createEffect(() => this.actions$.pipe(
        ofType(UserPermActions.updateUserInit),
        concatMap(action => this.userAppletService.getByGuid(action.guid, this.apiVisa)
            .pipe(
                map(a => a.data), // optional
                map(b => {
                    b.bl_applet_login_subject_link.rank = action.user.value.rank;

                    return b;
                }),
                concatMap(c => this.userAppletService.put(c, this.apiVisa).pipe(
                    map(c_inner => {
                        this.displayToasterSuccess('Rank for this user has been set');
                        return UserPermActions.updateUserSuccess();
                    })
                )),
                catchError(err => {
                    this.displayToasterError(err.message);
                    return of(UserPermActions.updateUserFailure({error: err.message}));
                })
            )
        )
    ))

    /**
     * Create new permission set.
     */
    createPermSet$ = createEffect(() => this.actions$.pipe(
        ofType(UserPermActions.createPermSetInit),
        mergeMap(action => this.permSetService.post(action.permSet, this.apiVisa)
        .pipe(
            map(response => {
                console.log("action: ", action);
                console.log("response: ", response);
                this.displayToasterSuccess('Permission set created successfully');
                // return UserPermActions.createPermSetSuccess();
                return UserPermActions.addPermSetInit({assigneeHdrTable: action.assigneeHdrTable, appletGuid: action.appletGuid, permSet: response.data});
            }),
            catchError((err) => {
                this.displayToasterError(err.message);
                return of(UserPermActions.createPermSetFailure({error: err.message}))
            })
        )),
        catchError((err) => {
            this.displayToasterError(err.message);
            return of(UserPermActions.createPermSetFailure({error: err.message}))
        })
    ))

    /**
     * Unlink permission set.
     */
    unlinkPermSet$ = createEffect(() => this.actions$.pipe(
        ofType(UserPermActions.unlinkPermSetInit),
        withLatestFrom(
            this.store.select(UserPermSelectors.selectSelectedUser),
            this.store.select(UserPermSelectors.selectSelectedRole)
        ),
        map(([action, user, role]) => {

            let dto: any;
            if(action.assigneeHdrTable == "app_mst_role") {
                dto = {
                    "assignee_hdr_table": "app_mst_role",
                    "assignee_guid": role.app_mst_role.guid,
                    "applet_guid": action.appletGuid,
                    "perm_set_hdr_guids": [action.permSetGuid]
                }
            }
            else if(action.assigneeHdrTable == "app_login_subject") {
                dto = {
                    "assignee_hdr_table": "app_login_subject",
                    "assignee_guid": user.app_login_principal_email.subject_guid,
                    "applet_guid": action.appletGuid,
                    "perm_set_hdr_guids": [action.permSetGuid]
                }
            }


            console.log("dto: ",dto);
            console.log("action.permSetGuid",action.permSetGuid);
            return dto;
        }),
        exhaustMap(a => this.tenantPermissionAssigneeTargetLinkService.deletePermSetListing(a, this.apiVisa)
        .pipe(
            map(_ => {
                this.displayToasterSuccess('Permission set unlinked successfully');
                return UserPermActions.unlinkPermSetSuccess();
            }),
            catchError((err) => {
                this.displayToasterError(err.message);
                return of(UserPermActions.unlinkPermSetFailure({error: err.message}))
            })
        ))
    ))

    /**
     * Add new permission set.
     */
    addPermSet$ = createEffect(() => this.actions$.pipe(
        ofType(UserPermActions.addPermSetInit),
        withLatestFrom(
            this.store.select(UserPermSelectors.selectSelectedUser),
            this.store.select(UserPermSelectors.selectSelectedRole)
        ),
        map(([action, user, role]) => {

            // let permSetGuid: string;

            // const criteria = [
            //     {columnName: 'code', operator: '=', value: action.permSet.app_perm_set_hdr.code.toString()},
            // ]

            // const pagination = new Pagination(null, null, criteria);

            // this.permSetService.getByCriteria(pagination, this.apiVisa)
            // .pipe(
            //     concatMap(x => x.data),
            //     mergeMap((x : PermissionSetContainerModel) => {
            //         permSetGuid = x.app_perm_set_hdr.guid.toString();
            //         console.log("x:",x);
            //         console.log("permSetGuid:",permSetGuid);
            //         return permSetGuid;
            //     })
            // )

            let dto: any;
            if(action.assigneeHdrTable == "app_mst_role") {
                dto = {
                    "assignee_hdr_table": "app_mst_role",
                    "assignee_guid": role.app_mst_role.guid,
                    "applet_guid": action.appletGuid,
                    "perm_set_hdr_guids": [action.permSet.app_perm_set_hdr.guid]
                }
            }
            else if(action.assigneeHdrTable == "app_login_subject") {
                dto = {
                    "assignee_hdr_table": "app_login_subject",
                    "assignee_guid": user.app_login_principal_email.subject_guid,
                    "applet_guid": action.appletGuid,
                    "perm_set_hdr_guids": [action.permSet.app_perm_set_hdr.guid]
                }
            }


            console.log("dto: ",dto);
            console.log("action.permSet.app_perm_set_hdr.guid",action.permSet.app_perm_set_hdr.guid);
            // console.log("action.permSet.app_perm_set_hdr.guid.valueOf()",action.permSet.app_perm_set_hdr.guid);
            return dto;
        }),
        exhaustMap(a => this.tenantPermissionAssigneeTargetLinkService.addPermSetListing(a, this.apiVisa)
        .pipe(
            map(_ => {
                this.displayToasterSuccess('Permission set added successfully');
                return UserPermActions.addPermSetSuccess();
            }),
            catchError((err) => {
                this.displayToasterError(err.message);
                return of(UserPermActions.addPermSetFailure({error: err.message}))
            })
        ))
    ))

    constructor(
        private userAppletService: UserAppletService,
        private permSetService: PermissionSetService,
        private tenantPermissionAssigneeTargetLinkService: TenantPermissionAssigneeTargetLinkService,
        private store: Store<PermissionStates>,
        private actions$: Actions,
        private toaster: ToastrService
    ) {};

    /**
     * Display a successful toaster message.
     *
     * @param message : the message to display
     * @returns the toaster
     */
    displayToasterSuccess(message: string) {
        return this.toaster.success(
            message,
            'Success',
            {
                tapToDismiss: true,
                progressBar: true,
                timeOut: 1300
            }
        )
    }

    /**
     * Display a toaster when there is an error.
     *
     * @param message : the messsage to display
     * @returns the toaster
     */
    displayToasterError(message: string) {
        return this.toaster.error(
            message,
            'Error',
            {
                tapToDismiss: true,
                progressBar: true,
                timeOut: 1300
            }
        )
    }

}
